import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

export default function StartPage({ paramValue , sponsorshipModule,  headerTitle, windowHeight, wordData, clientName , setIspaly ,setIsInfoModalOpen }) {


  function setWelcomePage(){
    setIspaly(true);
    if (localStorage.getItem('isReload') == 'done') {
      if (!localStorage.getItem('inModel')) {
        setIsInfoModalOpen(true);
        localStorage.setItem('inModel', 'done')
      }

      localStorage.setItem('puzzle_id', btoa(wordData.id))
    }
   
  }
  let divideHeight = '';
  if(sponsorshipModule ==  true && (paramValue === 'null' || paramValue == 'null' || !paramValue)){
    divideHeight = 120;
  }else{
    divideHeight = 59.5;
  }
  // *******************************

  
  const [isMobile, setIsMobile] = useState(false);
  const [elementHeight, setElementHeight] = useState(0);

  const divRef = useRef(null);

  useLayoutEffect(() => {
    // Check if the device is mobile
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isMobileDevice = /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
    setIsMobile(isMobileDevice);

    // Function to calculate element height
    const updateHeight = () => {
      if (divRef.current) {
        setElementHeight(divRef.current.offsetHeight); // Get the height of the div
      }
    };

    // Use setTimeout with a small delay to ensure DOM is fully painted
    const timeoutId = setTimeout(() => {
      updateHeight(); // Call updateHeight after a small delay to make sure it's rendered
    }, 50); // Delay by 50ms (you can adjust this based on your needs)

    window.addEventListener("resize", updateHeight); // Recalculate on window resize

    // Cleanup function to remove event listeners and clear timeout
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", updateHeight);
    };
  }, [isMobile]);




  return (
    <div>
    <div className="startup_page_main mx-width" style={{ height: `${(windowHeight - divideHeight) - elementHeight}px` }} >
      <div className="welcome">
        <div className="flex justify-center" >
        <img style={{ height: "80px" }} src="/wave.png" />
        </div>
        <div className="welcome-text">Welcome!</div>
      </div>
      <div className="welcome-heading">
        <div className="welcome-heading-text">
         <p> You have 6 tries to guess a word connected to news from</p>
          </div>
        <div className="customer-name">
          <p>{clientName}.</p>

          </div>
      </div>
      <div className="spacer"></div>
      <div className="play-button">
        <button onClick={setWelcomePage} className="btn btn-dark play-btn" id="showModel2">
          Play
        </button>
      </div>
      
        {
          isMobile ? <div ref={divRef} className="ads-mob ads-mob-dev">sdkfjalsjfklajsdklfaklsjkldfsjljkl
          <img src="/wave.png"  style={{height : `${elementHeight}`}}/>
          </div> : null
        }
      

    </div>
    </div>
  );
}
